"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertLineWithFormula = exports.getLineFormulaByLeastSquares = void 0;
/**
 * Method to create a line of best fit for a series of datapoints
 * @link https://medium.com/@sahirnambiar/linear-least-squares-a-javascript-implementation-and-a-definitional-question-e3fba55a6d4b
 * @param values_x array of timestamps
 * @param values_y array of battery percentages
 * @returns
 */
const getLineFormulaByLeastSquares = (values_x, values_y) => {
    var x_sum = 0;
    var y_sum = 0;
    var xy_sum = 0;
    var xx_sum = 0;
    var count = 0;
    /*
     * The above is just for quick access, makes the program faster
     */
    var x = 0;
    var y = 0;
    var values_length = values_x.length;
    if (values_length != values_y.length) {
        throw new Error('The parameters values_x and values_y need to have same size!');
    }
    /*
     * Above and below cover edge cases
     */
    if (values_length === 0) {
        return null;
    }
    /*
     * Calculate the sum for each of the parts necessary.
     */
    for (let i = 0; i < values_length; i++) {
        x = values_x[i];
        y = values_y[i];
        x_sum += x;
        y_sum += y;
        xx_sum += x * x;
        xy_sum += x * y;
        count++;
    }
    /*
     * Calculate m and b for the line equation:
     * y = x * m + b
     */
    var gradient = (count * xy_sum - x_sum * y_sum) / (count * xx_sum - x_sum * x_sum);
    var intercept = y_sum / count - (gradient * x_sum) / count;
    /*
     * We then return the x and y data points according to our fit
     */
    // var result_values_x: number[] = [];
    // var result_values_y: number[] = [];
    // for (let i = 0; i < values_length; i++) {
    //   x = values_x[i];
    //   y = x * gradiant + intercept;
    //   result_values_x.push(x);
    //   result_values_y.push(y);
    // }
    // const forLoggin = result_values_x.map((val, i) => {
    //   return [val, result_values_y[i]];
    // });
    /**
     * Calculate the expected percentage drop
     */
    // let percentageDrop = values_x[values_x.length - 1] * gradient - values_x[0] * gradient;
    // console.log('percentageDrop', percentageDrop);
    // console.log('[gradiant, intercept]', [gradient, intercept]);
    return { gradient, intercept };
};
exports.getLineFormulaByLeastSquares = getLineFormulaByLeastSquares;
/**
 * A support parser that calculates a line using y=mx+c
 * @param gradiant
 * @param intercept
 * @param timeSeries Series of x positions
 * @returns
 */
const convertLineWithFormula = (gradiant, intercept, timeSeries) => {
    let values = timeSeries.map((timeX) => {
        return { x: timeX, y: gradiant * timeX + intercept };
    });
    return values;
};
exports.convertLineWithFormula = convertLineWithFormula;
